/**
 * Site Header
 */

var resizeTimer;

window.addEventListener('resize', () => {
  const body = document.body
  body.classList.add('u-resize-animation-stopper')
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    body.classList.remove('u-resize-animation-stopper')
  }, 400);
})